import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var AttachmentFileDto = function AttachmentFileDto() {
  _classCallCheck(this, AttachmentFileDto);

  _defineProperty(this, "id", void 0);

  _defineProperty(this, "fileName", void 0);

  _defineProperty(this, "fileMimeType", void 0);

  _defineProperty(this, "url", void 0);

  _defineProperty(this, "fileSize", void 0);
};